import { styled } from '@linaria/react';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';

const NotificationIcon = styled.div<NotificationIconProps>`
  width: ${props => props.width ? props.width : '32px'};
  height: ${props => props.height ? props.height : '32px'};
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    object-fit: contain;
  }
`;


const NotificationLayout = styled.div`
  display: flex;
  column-gap: 8px;
  overflow-wrap: anywhere;
  @media screen and (min-width: 768px) {
    column-gap: 16px;
    overflow-wrap: unset;
  }
`;

const MessageContentContainer = styled.div<MessageContentProps>`
  display: flex;
  flex-direction: column;
  flex-direction: row;
  row-gap: ${props => props.rowGap ? props.rowGap : "16px"};
  position:relative;
`;

const ErrorMessageBoxContainer = styled.div<ErrorMessageBoxProps>`
  position: relative;
  overflow: hidden;
  flex:1;
  background-color: #FFE9EC;
  border-radius: ${props => props.radius ? props.radius : "0px"};
  padding: 16px;
  margin: ${props => props.margin ? props.margin : "0"};
  @media screen and (min-width: 768px) {
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0px 4px 16px rgba(204, 204, 204, 0.5);
  }
`;
const ErrorBoxLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background-color: #C50000;
`;

export interface ErrorMessageBoxProps {
  children: JSX.Element;
  margin?: string | undefined;
  radius?: string;
}

export interface MessageContentProps {
  children?: React.ReactNode;
  rowGap?: string;
  amount?: number;
  isCalculating?: boolean;
  iconProps?: NotificationIconProps
}

export interface NotificationIconProps {
  width?: string;
  height?: string;
}




const MessageContent = ({ children, rowGap, isCalculating, amount = 0, iconProps }: MessageContentProps) => {

  const [budetCalculatorUrl, setBudgetCalculatorUrl] = useState<string>("");

  useEffect(() => {
    if (!budetCalculatorUrl) {
      let url = get(window, 'AVIVA_VARIABLE_CONFIG.budgetCalculatorUrl', "");
      setBudgetCalculatorUrl(url);
    }
  }, [budetCalculatorUrl, setBudgetCalculatorUrl]);

  return (
    <NotificationLayout>
      <div style={{ flex: 0 }}>
        <NotificationIcon {...iconProps}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#C50000" />
            <path d="M12.525 15.5006L12.9501 6.99875C12.9772 6.45541 12.544 6 12 6C11.456 6 11.0228 6.45542 11.0499 6.99875L11.475 15.5006C11.489 15.7804 11.7199 16 12 16C12.2801 16 12.511 15.7804 12.525 15.5006Z" fill="#C50000" />
            <circle cx="12" cy="18" r="1" fill="#C50000" />
          </svg>
        </NotificationIcon>
      </div>
      {children && <MessageContentContainer rowGap={rowGap}>{children}</MessageContentContainer>}
    </NotificationLayout>
  );
};

const ErrorMessageBox = ({ ...props }: ErrorMessageBoxProps) => {
  return <ErrorMessageBoxContainer margin={props.margin} radius={props.radius}>
    <>
      {props.children}
      <ErrorBoxLine />
    </>
  </ErrorMessageBoxContainer>;
};

export { ErrorMessageBox, MessageContent };
